const Checkout = () => {
    return (
        <div className="container mx-auto px-4">
            <div className="flex shadow-md my-10">
                <h1>Checkout</h1>
            </div>
        </div>
    )
}

export default Checkout;